import all from './all';
import confirm from './confirm';

export default {
  all,
  confirm,
};



// WEBPACK FOOTER //
// ./src/app/services/ediOrderItem/index.js